import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-status-text',
    templateUrl: './status-text.component.html',
    styleUrls: ['./status-text.component.scss']
})
export class StatusTextComponent {
    @HostBinding('class.active') @Input() public active: boolean;
    @Input() public title: string;
}
